var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview__image-wrapper"},[(!_vm.loaded)?_c('div',{staticClass:"preview__loading"}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"preview__image",class:{ 'preview--hidden': !_vm.loaded },attrs:{"src":_vm.url},on:{"load":function($event){_vm.loaded = true}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }